/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://dh-static.mesos.nrk.no/dh-inngang-stor/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rerender", function() { return rerender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p,
	    list = items;
	items = [];
	while (p = list.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		if (old) old(null);
		if (value) value(node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.pop()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	if (component.__ref) component.__ref(component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.unshift(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	if (component.__ref) component.__ref(null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* harmony default export */ __webpack_exports__["default"] = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function shallowEqual(a, b) {
  for (var key in a) {
    if (a[key] !== b[key]) return false;
  }for (var _key in b) {
    if (!(_key in a)) return false;
  }return true;
}

var PureComponent = function (_Component) {
  _inherits(PureComponent, _Component);

  function PureComponent() {
    _classCallCheck(this, PureComponent);

    return _possibleConstructorReturn(this, (PureComponent.__proto__ || Object.getPrototypeOf(PureComponent)).apply(this, arguments));
  }

  _createClass(PureComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(props, state) {
      return !(shallowEqual(props, this.props) && shallowEqual(state, this.state));
    }
  }]);

  return PureComponent;
}(_preact.Component);

exports.default = PureComponent;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = exports.getScrollTop = exports.getScrollLeft = exports.createUniqueId = exports.bem = undefined;

var _array = __webpack_require__(14);

var _bem = __webpack_require__(15);

var _bem2 = _interopRequireDefault(_bem);

var _scroll = __webpack_require__(16);

var _string = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bem = _bem2.default;
exports.createUniqueId = _string.createUniqueId;
exports.getScrollLeft = _scroll.getScrollLeft;
exports.getScrollTop = _scroll.getScrollTop;
exports.toArray = _array.toArray;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.nrkSerumImagecropUtils = {});
})(undefined, function (exports) {
  'use strict';

  var isPolopolyIdRegex = /^[1-9]{1,2}\.\d+$/;

  function isPolopolyId(id) {
    if (!id) {
      return false;
    }
    return isPolopolyIdRegex.test(id);
  }

  // prettier-ignore
  var widths = [100, 120, 150, 174, 200, 206, 225, 244, 250, 252, 300, 320, 350, 400, 450, 452, 460, 462, 500, 600, 650, 665, 682, 700, 734, 768, 900, 974, 1200, 1280, 1360, 1450, 1550, 1600, 1700, 1800, 1920, 2000, 2100, 2200, 2300, 2400];

  // prettier-ignore
  var ratios = ['1:1', '11', '16:9', '169', '16:3', '163', '3:4', '34'];

  // prettier-ignore
  var qualities = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0];

  var _baseUrl = 'https://nrk.no/serum/api/imagecrop/';

  function createUrl(_ref) {
    var id = _ref.id,
        ratio = _ref.ratio,
        width = _ref.width,
        quality = _ref.quality;

    var url = '' + _baseUrl + id;
    var queryString = createQueryString({ ratio: ratio, width: width, quality: quality });
    if (queryString) {
      url += '?' + queryString;
    }
    return url;
  }

  function createQueryString(_ref2) {
    var ratio = _ref2.ratio,
        width = _ref2.width,
        quality = _ref2.quality;

    if (!ratio && !width) {
      return quality ? 'quality=' + quality : '';
    }
    var ratioPart = ratio ? 'f' + ratio.replace(':', '') : '';
    var widthPart = width ? 'w' + width : '';
    var qualityPart = quality ? '&quality=' + quality : '';
    return 'cropid=' + ratioPart + widthPart + qualityPart;
  }

  function getClosestNumber(goal, targets) {
    if (!isValidGoal(goal)) {
      throw new Error('\n      getClosestNumber(goal, targets): passing a goal of ' + goal + '\n      is not supported. Pass a number');
    }
    if (!isValidTargets(targets)) {
      throw new Error('\n      getClosestNumber(goal, targets): targets ' + targets.toString() + ' is invald.\n      Pass an array of numbers');
    }
    if (!targets.length) {
      // eslint-disable-next-line no-undefined
      return undefined;
    }
    return targets.reduce(function (prev, curr) {
      return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
    });
  }

  function isValidGoal(goal) {
    return typeof goal === 'number';
  }

  function isValidTargets(targets) {
    if (!targets) {
      return false;
    }
    var isValid = true;
    for (var i = 0; i < targets.length; i++) {
      if (typeof targets[i] !== 'number') {
        isValid = false;
        break;
      }
    }
    // return targets.some((target) => {
    //   return (typeof target !== 'number')
    // })
    return isValid;
  }

  function isValidRatio(ratio, supportedRatios) {
    if (!Array.isArray(supportedRatios)) {
      // eslint-disable-next-line no-useless-escape
      throw new Error("isValidRatio(ratio, supportedRatios): supportedRatios '" + supportedRatios + "' is not supported. Pass an array of supported ratios");
    }
    if (!ratio) {
      return false;
    }
    return supportedRatios.includes(ratio);
  }

  function isValidQuality(quality, supportedQualities) {
    if (!Array.isArray(supportedQualities)) {
      // eslint-disable-next-line no-useless-escape
      throw new Error("isValidQuality(quality, supportedQualities): supportedQualities '" + supportedQualities + "' is not supported. Pass an array of supported qualities");
    }
    if (!quality) {
      return false;
    }
    return supportedQualities.includes(quality);
  }

  function createImageUrl(options) {
    var polopolyId = options.id,
        width = options.width,
        ratio = options.ratio,
        quality = options.quality;

    if (!isPolopolyId(polopolyId)) {
      throw new Error('createSerumImageUrl(): invalid polopolyId. Got ' + polopolyId);
    }

    var args = {
      id: polopolyId,
      ratio: null,
      quality: 0.8,
      width: 0

      // If a ratio is provided, ensure that it is valid
    };if (hasOption(ratio)) {
      if (!isValidRatio(ratio, ratios)) {
        throw new Error('\n      createSerumImageUrl(): ratio ' + ratio + ' is not supported.\n      Supported ratios are ' + ratios.toString());
      }
      args.ratio = ratio;
    }

    // If a quality is provided, ensure that it is valid
    if (hasOption(quality)) {
      if (!isValidQuality(quality, qualities)) {
        throw new Error('\n      createSerumImageUrl(): quality ' + quality + ' is not supported.\n      Supported qualities are ' + qualities.toString());
      }
      args.quality = quality;
    }

    // If a width is provided, ensure that is is a positive integer
    if (hasOption(width)) {
      if (!isNumber(width) || width <= 0) {
        var errorMessage = 'createSerumImageUrl(): width must be a positive integer, got ' + width;
        throw new Error(errorMessage);
      }
      var isSupportedWidth = widths.includes(width);
      var closestWidth = getClosestNumber(width, widths);
      if (typeof closestWidth !== 'undefined' && closestWidth) {
        args.width = isSupportedWidth ? width : closestWidth;
      }
    }

    return createUrl(args);
  }

  function hasOption(option) {
    return typeof option !== 'undefined' && option;
  }

  function isNumber(number) {
    return Number.isInteger(number);
  }

  exports.createImageUrl = createImageUrl;
  exports.ratios = ratios;
  exports.widths = widths;
  exports.qualities = qualities;
  exports.isPolopolyId = isPolopolyId;

  Object.defineProperty(exports, '__esModule', { value: true });
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.getInitials = getInitials;

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(2);

var _AvatarImage = __webpack_require__(26);

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};

var Avatar = exports.Avatar = function (_Component) {
  _inherits(Avatar, _Component);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
  }

  _createClass(Avatar, [{
    key: 'render',
    value: function render() {
      var person = this.props.person;
      var name = person.name,
          image = person.image;

      var displayImage = image && image.type !== 'none';
      return (0, _preact.h)('div', { 'aria-hidden': true, className: (0, _dhUtils.bem)(styles.avatar, person.side) }, displayImage && (0, _preact.h)(_AvatarImage.AvatarImage, { image: image, alt: person.name, title: person.name }), !displayImage && (0, _preact.h)('span', { className: styles.avatar__placeholder, title: name }, getInitials(name)));
    }
  }]);

  return Avatar;
}(_preact.Component);

function getInitials() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var initials = name.replace(/\(.*\)/, '').trim().split(/[ -]/).map(function (item) {
    return item.charAt(0).toUpperCase();
  });

  if (initials.length < 2) return initials[0];
  return [initials[0], initials[initials.length - 1]].join('');
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageUrl = getImageUrl;

var _serumImagecropUtils = __webpack_require__(3);

function getImageUrl(image, options) {
  var _ref = options || {},
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 120 : _ref$width,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === undefined ? '1:1' : _ref$ratio;

  switch (image.type) {
    case 'polopoly-image':
      {
        return (0, _serumImagecropUtils.createImageUrl)({ id: image.id, width: width, ratio: ratio });
      }
    case 'url-image':
      {
        return image.url;
      }
  }
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

/* eslint-disable jsx-a11y/media-has-caption */

var Video = function (_PureComponent) {
  _inherits(Video, _PureComponent);

  function Video() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Video);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Video.__proto__ || Object.getPrototypeOf(Video)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isPlaying: false,
      isResolvingPlay: false,
      time: 0
    }, _this.tracks = [], _this.handlePlay = function () {
      var onPlay = _this.props.onPlay;

      _this.setState({ isPlaying: true });

      if (onPlay) {
        onPlay();
      }
    }, _this.handlePause = function () {
      var onPause = _this.props.onPause;

      _this.setState({ isPlaying: false });

      if (onPause) {
        onPause();
      }
    }, _this.handleDurationChange = function () {
      var onDurationChange = _this.props.onDurationChange;

      if (onDurationChange) {
        onDurationChange(_this.elm.duration);
      }
    }, _this.handleTimeupdate = function () {
      var onTimeupdate = _this.props.onTimeupdate;

      var time = _this.elm.currentTime;

      _this.setState({ time: time });

      if (onTimeupdate) {
        onTimeupdate(time);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          textTracks = _props.textTracks,
          playing = _props.playing,
          onCaptionCueEnter = _props.onCaptionCueEnter,
          onCaptionCueExit = _props.onCaptionCueExit;

      if (textTracks) {
        textTracks.forEach(function (textTrack) {
          var track = _this2.elm.addTextTrack('subtitles', textTrack.language);
          track.mode = 'hidden';

          _this2.tracks.push(track);

          try {
            textTrack.captions.forEach(function (a) {
              return track.addCue(new window.VTTCue(Number(a.in), Number(a.out), a.text));
            });
          } catch (_) {
            // ignore error

            textTrack.captions.forEach(function (a) {
              return track.addCue(new window.TextTrackCue(Number(a.in), Number(a.out), a.text));
            });
          }

          var _loop = function _loop(i) {
            var cue = track.cues[i];

            try {
              cue.onenter = function () {
                if (typeof onCaptionCueEnter !== 'undefined') {
                  onCaptionCueEnter({
                    in: cue.startTime,
                    out: cue.endTime,
                    text: cue.text
                  });
                }
              };
              cue.onexit = function () {
                if (typeof onCaptionCueExit !== 'undefined') {
                  onCaptionCueExit();
                }
              };
            } catch (_) {
              // ignore error
            }
          };

          for (var i = 0; i < track.cues.length; i++) {
            _loop(i);
          }
        });
      }

      if (playing) {
        this.play();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.playing !== this.props.playing) {
        if (this.props.playing) {
          this.play();
        } else {
          this.pause();
        }
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var _this3 = this;

      var onError = this.props.onError;

      var playPromise = this.elm.play();

      if (playPromise) {
        this.setState({ isResolvingPlay: true });

        playPromise.then(function () {
          _this3.setState({ isResolvingPlay: false });
        }).catch(function (err) {
          if (onError) {
            onError(err.message);
          }

          _this3.setState({ isResolvingPlay: false });
        });
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.elm.pause();
    }
  }, {
    key: 'seek',
    value: function seek(time) {
      this.elm.currentTime = time;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          playing = _props2.playing,
          sources = _props2.sources,
          restProps = _objectWithoutProperties(_props2, ['playing', 'sources']);

      var isPlaying = this.state.isPlaying;

      var eventHandlers = {
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onDurationChange: this.handleDurationChange,
        onTimeupdate: this.handleTimeupdate
      };

      var dataProps = {};

      if (isPlaying) {
        dataProps['data-playing'] = true;
      }

      return (0, _preact.h)('video', _extends({}, restProps, eventHandlers, {
        ref: function ref(elm) {
          return _this4.elm = elm;
        }
      }, dataProps), sources.map(function (source) {
        return (0, _preact.h)('source', _extends({}, source, { key: source.type }));
      }));
    }
  }]);

  return Video;
}(_preactPureComponent2.default);

exports.default = Video;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMAGE_WIDTHS = undefined;
exports.createResponsiveSrcSet = createResponsiveSrcSet;

var _serumImagecropUtils = __webpack_require__(3);

var IMAGE_WIDTHS = exports.IMAGE_WIDTHS = [320, 450, 650, 768, 900, 1280, 1600, 1920, 2400];

function createResponsiveSrcSet(opts) {
  var id = opts.id,
      ratio = opts.ratio,
      quality = opts.quality;

  return IMAGE_WIDTHS.map(function (width) {
    var imageUrl = (0, _serumImagecropUtils.createImageUrl)({ id: id, width: width, ratio: ratio, quality: quality });
    return imageUrl + ' ' + width + 'w';
  }).join(', ');
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connect = exports.Provider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h


var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      return { '__CTX__': props };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children[0];
    }
  }]);

  return Provider;
}(_preact.Component);

Provider.displayName = 'Provider';

function connect(mapContextToProps) {
  return function (wrappedComponent) {
    var Connected = function (_Component2) {
      _inherits(Connected, _Component2);

      function Connected() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, Connected);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Connected.__proto__ || Object.getPrototypeOf(Connected)).call.apply(_ref, [this].concat(args))), _this2), _this2.mapContextToProps = function (ctx) {
          return mapContextToProps ? mapContextToProps(ctx) : ctx;
        }, _temp), _possibleConstructorReturn(_this2, _ret);
      }

      _createClass(Connected, [{
        key: 'render',
        value: function render() {
          return (0, _preact.h)(wrappedComponent, _extends({}, this.mapContextToProps(this.context['__CTX__']), this.props));
        }
      }]);

      return Connected;
    }(_preact.Component);

    Connected.displayName = 'connect(' + (wrappedComponent.displayName || wrappedComponent.name || 'Component') + ')';
    return Connected;
  };
}

exports.Provider = Provider;
exports.connect = connect;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"dh-dh-inngang-stor-root","app":"dh-dh-inngang-stor-app","plugWrapper":"dh-dh-inngang-stor-plugWrapper","plugContent":"dh-dh-inngang-stor-plugContent","plugFullWidth":"dh-dh-inngang-stor-plugFullWidth","plugHalfWidth":"dh-dh-inngang-stor-plugHalfWidth","plugTitleWrapper":"dh-dh-inngang-stor-plugTitleWrapper","plugTitle":"dh-dh-inngang-stor-plugTitle","plugLead":"dh-dh-inngang-stor-plugLead","plugButton":"dh-dh-inngang-stor-plugButton","plugOverlay":"dh-dh-inngang-stor-plugOverlay","plug__imageContainer":"dh-dh-inngang-stor-plug__imageContainer","themeOrderud":"dh-dh-inngang-stor-themeOrderud","plug__imageContainer--2images":"dh-dh-inngang-stor-plug__imageContainer--2images","zoomAnimation2":"dh-dh-inngang-stor-zoomAnimation2","plug__imageContainer--3images":"dh-dh-inngang-stor-plug__imageContainer--3images","zoomAnimation3":"dh-dh-inngang-stor-zoomAnimation3"};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(11);
module.exports = __webpack_require__(12);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global __HOT__ */
// @jsx h


var _domready = __webpack_require__(13);

var _domready2 = _interopRequireDefault(_domready);

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(2);

var _errorReporting = __webpack_require__(18);

var _App = __webpack_require__(20);

var _App2 = __webpack_require__(9);

var _dhAnalyticsUtils = __webpack_require__(53);

var _getContextId = __webpack_require__(54);

var _provider = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window[_App2.root] = window[_App2.root] || {};

function init() {
  findElements(_App2.root).forEach(function (el) {
    el.id = (0, _dhUtils.createUniqueId)();
    window[_App2.root][el.id] = true;

    // Extract values sent from server
    var name = el.getAttribute('data-name');
    var preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'));
    var errorTrackingEnabled = el.getAttribute('data-error-tracking-enabled') === 'true';

    // setup error reporting
    var simpleErrorReport = (0, _errorReporting.createErrorReporter)(name, errorTrackingEnabled);
    simpleErrorReport.listenAndCatch();

    // Extract metadata required to create google analytics tracker
    var gaPropertyId = el.getAttribute('data-ga-property-id');
    var metadata = JSON.parse(el.getAttribute('data-metadata'));
    var title = metadata.title,
        selfId = metadata.selfId,
        published = metadata.published;

    // create google analytics tracker

    var googleAnalyticsTracker = (0, _dhAnalyticsUtils.createGoogleAnalyticsTracker)({
      name: 'dh',
      gaPropertyId: gaPropertyId,
      self: {
        id: selfId,
        title: title,
        publishedDate: published ? new Date(published) : null
      },
      context: {
        id: (0, _getContextId.getContextId)(document.location.href)
      }
    });

    var sendError = function sendError(message) {
      simpleErrorReport.sendErrorReport({ message: message });
    };

    var sendGaEvent = function sendGaEvent(eventObj) {
      googleAnalyticsTracker.sendEvent(_extends({
        category: 'dh-modul-' + name
      }, eventObj));
    };

    // ... and render with the exact same props as on server
    (0, _preact.render)((0, _preact.h)(
      _provider.Provider,
      { sendGaEvent: sendGaEvent, sendError: sendError },
      (0, _preact.h)(_App.App, preloadedState)
    ), el, el.firstChild);

    // Enable webpack hot-reloading
    if (false) {
      // Reload and re-render preact application
      module.hot.accept('./client', function () {
        var _require = require('./components/App'),
            App = _require.App;

        var _require2 = require('../lib/provider'),
            CustomProvider = _require2.Provider;

        (0, _preact.render)((0, _preact.h)(
          CustomProvider,
          { sendGaEvent: sendGaEvent, sendError: sendError },
          (0, _preact.h)(App, preloadedState)
        ), el, el.firstChild);
      });
    }
  });
}

if (false) {
  require('preact/debug');
}

function findElements(className) {
  return (0, _dhUtils.toArray)(document.getElementsByClassName(className)).filter(function (el) {
    return !isInitialized(el, className);
  });
}

function isInitialized(el, className) {
  return el.id && window[className][el.id];
}

(0, _domready2.default)(init);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  if (true) module.exports = definition();else if (typeof define == 'function' && _typeof(define.amd) == 'object') define(definition);else this[name] = definition();
}('domready', function () {

  var fns = [],
      _listener,
      doc = document,
      hack = doc.documentElement.doScroll,
      domContentLoaded = 'DOMContentLoaded',
      loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);

  if (!loaded) doc.addEventListener(domContentLoaded, _listener = function listener() {
    doc.removeEventListener(domContentLoaded, _listener);
    loaded = 1;
    while (_listener = fns.shift()) {
      _listener();
    }
  });

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  };
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = toArray;
function toArray(nodeList) {
  return [].slice.call(nodeList);
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function toStrings(object) {
  return Object.keys(object).filter(function (key) {
    return object[key];
  });
}

exports.default = function (blockName) {
  for (var _len = arguments.length, modifiers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    modifiers[_key - 1] = arguments[_key];
  }

  var strings = modifiers.filter(function (modifier) {
    return typeof modifier === 'string';
  });
  var objects = modifiers.filter(function (modifier) {
    return (typeof modifier === 'undefined' ? 'undefined' : _typeof(modifier)) === 'object';
  });

  var objectString = objects.map(function (object) {
    return toStrings(object);
  }).reduce(function (a, b) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(b));
  }, []);

  return [blockName].concat(strings.map(function (modifier) {
    return blockName + '--' + modifier;
  })).concat(objectString.map(function (modifier) {
    return blockName + '--' + modifier;
  })).join(' ');
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollLeft = getScrollLeft;
exports.getScrollTop = getScrollTop;
function getScrollLeft() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.pageXOffset || document.documentElement && document.documentElement.scrollLeft || 0;
}

function getScrollTop() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.pageYOffset || document.documentElement && document.documentElement.scrollTop || 0;
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUniqueId = createUniqueId;
function createUniqueId() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return '' + prefix + Math.random().toString(36).substr(2, len - prefix.length);
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createErrorReporter = createErrorReporter;

var _dhSimpleErrorReport = __webpack_require__(19);

function createErrorReporter(name, isErrorReportingEnabled) {
  return new _dhSimpleErrorReport.SimpleErrorReport({
    name: name,
    url: 'https://dh.nrk.no/catch',
    dryRun: !isErrorReportingEnabled
  });
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : n(e["simple-error-report"] = {});
}(undefined, function (e) {
  "use strict";
  var n = function () {
    function e(e, n) {
      for (var r = 0; r < n.length; r++) {
        var t = n[r];t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }return function (n, r, t) {
      return r && e(n.prototype, r), t && e(n, t), n;
    };
  }();var r = function () {
    function e() {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.register = [];
    }return n(e, [{ key: "addErrorToRegister", value: function value(e) {
        this.register.push({ time: new Date(), message: e });
      } }, { key: "isInRegisterWithinRange", value: function value(e, n) {
        return this.register.filter(function (r) {
          return r.message === e && new Date() - r.time < n;
        }).length > 0;
      } }]), e;
  }(),
      t = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
      }
    }return e;
  },
      i = function () {
    function e(e, n) {
      for (var r = 0; r < n.length; r++) {
        var t = n[r];t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }return function (n, r, t) {
      return r && e(n.prototype, r), t && e(n, t), n;
    };
  }();var o = [],
      s = function () {
    function e(n) {
      var t = n.name,
          i = n.url,
          s = n.dryRun,
          a = void 0 === s || s,
          u = n.parseStack;!function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.name = t, this.url = i, this.errorRegister = new r(), this.dryRun = a, u && (this.parseStack = u), o.push(this.name);
    }return i(e, [{ key: "listenAndCatch", value: function value() {
        var e = this;o.length <= 1 && (window.addEventListener("error", function (n) {
          var r = n.message,
              i = n.filename,
              o = n.lineno,
              s = n.colno,
              a = { message: r };"" !== i && (a.url = i), o > 0 && (a.line = o), s > 0 && (a.column = s), n.error && "function" == typeof e.parseStack ? e.parseStack(n.error).then(function (n) {
            e.sendErrorReport(t({}, a, { stackTrace: n }));
          }) : e.sendErrorReport(a);
        }), window.addEventListener("unhandledrejection", function (n) {
          e.sendErrorReport({ message: "Unhandled Promise Rejection: " + n.reason });
        }));
      } }, { key: "sendErrorReport", value: function value(e) {
        var n, r, t;this.dryRun ? "undefined" != typeof console && console.log("Dry run: " + JSON.stringify(e)) : this.errorRegister.isInRegisterWithinRange(e.message, 500) || (this.errorRegister.addErrorToRegister(e.message), n = this.url + "/" + this.name, r = e, (t = new XMLHttpRequest()).open("POST", n), t.setRequestHeader("Content-Type", "application/json"), t.send(JSON.stringify(r)));
      } }]), e;
  }();e.SimpleErrorReport = s, Object.defineProperty(e, "__esModule", { value: !0 });
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _dhFeatureComponents = __webpack_require__(21);

var _dhUtils = __webpack_require__(2);

var _provider = __webpack_require__(8);

var _App2 = __webpack_require__(9);

var _App3 = _interopRequireDefault(_App2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h


/* styles */


function toArray(str) {
  return (str || '').split(',').map(function (str) {
    return str.trim();
  });
}

var _App = function (_Component) {
  _inherits(_App, _Component);

  function _App() {
    _classCallCheck(this, _App);

    return _possibleConstructorReturn(this, (_App.__proto__ || Object.getPrototypeOf(_App)).apply(this, arguments));
  }

  _createClass(_App, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          link = _props.link,
          title = _props.title,
          lead = _props.lead,
          images = _props.images,
          theme = _props.theme;

      var imageList = toArray(images);
      var themeClass = function themeClass() {
        switch (theme) {
          case 'theme-orderud':
            return _App3.default.themeOrderud;
          default:
            return 'themeDefault';
        }
      };
      return (0, _preact.h)(
        'div',
        { 'class': _App3.default.app + ' ' + themeClass() },
        (0, _preact.h)(
          'div',
          { 'class': _App3.default.plugWrapper + ' ' + _App3.default.plugFullWidth + ' nrk-aspect nrk-aspect--16x9' },
          (0, _preact.h)(
            'a',
            { href: link, 'class': _App3.default.plugContent },
            (0, _preact.h)(
              'h2',
              { 'class': _App3.default.plugTitle },
              title
            ),
            (0, _preact.h)(
              'div',
              { 'class': _App3.default.plugLead },
              (0, _preact.h)(
                'p',
                null,
                lead
              ),
              (0, _preact.h)(
                'div',
                { 'class': _App3.default.plugButton },
                (0, _preact.h)(
                  'svg',
                  { style: 'width: 1.5em; height: 1.5em', 'aria-hidden': 'true' },
                  (0, _preact.h)('use', { xlinkHref: '#nrk-chevron-right' })
                )
              )
            )
          ),
          images && (0, _preact.h)(
            'div',
            { className: (0, _dhUtils.bem)(_App3.default.plug__imageContainer, imageList.length + 'images'), 'aria-hidden': 'true' },
            imageList.map(function (imageId) {
              return (0, _preact.h)(_dhFeatureComponents.SerumResponsivePicture, { key: imageId, id: imageId });
            })
          ),
          (0, _preact.h)('div', { 'class': _App3.default.plugOverlay })
        )
      );
    }
  }]);

  return _App;
}(_preact.Component);

var connector = (0, _provider.connect)();
var App = exports.App = connector(_App);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewportIntersections = exports.VideoPlayer = exports.Video = exports.SmartVideo = exports.Slideshow = exports.Slide = exports.SerumLazyResponsivePicture = exports.SerumResponsivePicture = exports.SerumSmartPicture = exports.SerumImage = exports.ResponsiveVideo = exports.PureComponent = exports.PullQuote = exports.Paragraph = exports.ListItem = exports.List = exports.Icon = exports.Heading = exports.Figure = exports.EmailList = exports.ChatLog = exports.Byline = undefined;

var _Byline = __webpack_require__(22);

var _Byline2 = _interopRequireDefault(_Byline);

var _ChatLog = __webpack_require__(23);

var _ChatLog2 = _interopRequireDefault(_ChatLog);

var _EmailList = __webpack_require__(30);

var _EmailList2 = _interopRequireDefault(_EmailList);

var _Figure = __webpack_require__(32);

var _Figure2 = _interopRequireDefault(_Figure);

var _Heading = __webpack_require__(33);

var _Heading2 = _interopRequireDefault(_Heading);

var _Icon = __webpack_require__(34);

var _Icon2 = _interopRequireDefault(_Icon);

var _List = __webpack_require__(35);

var _List2 = _interopRequireDefault(_List);

var _ListItem = __webpack_require__(36);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Paragraph = __webpack_require__(37);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

var _PullQuote = __webpack_require__(38);

var _PullQuote2 = _interopRequireDefault(_PullQuote);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

var _ResponsiveVideo = __webpack_require__(39);

var _ResponsiveVideo2 = _interopRequireDefault(_ResponsiveVideo);

var _SerumImage = __webpack_require__(40);

var _SerumImage2 = _interopRequireDefault(_SerumImage);

var _SerumResponsivePicture = __webpack_require__(41);

var _SerumResponsivePicture2 = _interopRequireDefault(_SerumResponsivePicture);

var _SerumSmartPicture = __webpack_require__(42);

var _SerumSmartPicture2 = _interopRequireDefault(_SerumSmartPicture);

var _SerumLazyResponsivePicture = __webpack_require__(43);

var _SerumLazyResponsivePicture2 = _interopRequireDefault(_SerumLazyResponsivePicture);

var _Slide = __webpack_require__(44);

var _Slide2 = _interopRequireDefault(_Slide);

var _Slideshow = __webpack_require__(45);

var _Slideshow2 = _interopRequireDefault(_Slideshow);

var _SmartVideo = __webpack_require__(46);

var _SmartVideo2 = _interopRequireDefault(_SmartVideo);

var _Video = __webpack_require__(6);

var _Video2 = _interopRequireDefault(_Video);

var _VideoPlayer = __webpack_require__(47);

var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);

var _ViewportIntersections = __webpack_require__(52);

var _ViewportIntersections2 = _interopRequireDefault(_ViewportIntersections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Byline = _Byline2.default;
exports.ChatLog = _ChatLog2.default;
exports.EmailList = _EmailList2.default;
exports.Figure = _Figure2.default;
exports.Heading = _Heading2.default;
exports.Icon = _Icon2.default;
exports.List = _List2.default;
exports.ListItem = _ListItem2.default;
exports.Paragraph = _Paragraph2.default;
exports.PullQuote = _PullQuote2.default;
exports.PureComponent = _preactPureComponent2.default;
exports.ResponsiveVideo = _ResponsiveVideo2.default;
exports.SerumImage = _SerumImage2.default;
exports.SerumSmartPicture = _SerumSmartPicture2.default;
exports.SerumResponsivePicture = _SerumResponsivePicture2.default;
exports.SerumLazyResponsivePicture = _SerumLazyResponsivePicture2.default;
exports.Slide = _Slide2.default;
exports.Slideshow = _Slideshow2.default;
exports.SmartVideo = _SmartVideo2.default;
exports.Video = _Video2.default;
exports.VideoPlayer = _VideoPlayer2.default;
exports.ViewportIntersections = _ViewportIntersections2.default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var style = {
  'byline': 'dhfc-1_0_0-beta_26-byline',
  'byline__name': 'dhfc-1_0_0-beta_26-byline__name'
};

var Byline = function (_PureComponent) {
  _inherits(Byline, _PureComponent);

  function Byline() {
    _classCallCheck(this, Byline);

    return _possibleConstructorReturn(this, (Byline.__proto__ || Object.getPrototypeOf(Byline)).apply(this, arguments));
  }

  _createClass(Byline, [{
    key: 'render',
    value: function render() {
      var authors = this.props.authors;

      var len = authors.length;
      var className = '' + style.byline + (this.props.className ? ' ' + this.props.className : '');

      if (len === 0) return null;

      return (0, _preact.h)('div', { className: className }, 'Av', ' ', authors.map(function (author, idx) {
        if (len === 1) {
          return (0, _preact.h)('span', { key: String(idx) }, (0, _preact.h)('span', {
            className: style.byline__name,
            dangerouslySetInnerHTML: { __html: author.name }
          }));
        }

        if (idx === len - 1) {
          return (0, _preact.h)('span', { key: String(idx) }, '&', ' ', (0, _preact.h)('span', {
            className: style.byline__name,
            dangerouslySetInnerHTML: { __html: author.name }
          }));
        }

        if (idx === len - 2) {
          return (0, _preact.h)('span', { key: String(idx) }, (0, _preact.h)('span', {
            className: style.byline__name,
            dangerouslySetInnerHTML: { __html: author.name }
          }), ' ');
        }

        return (0, _preact.h)('span', { key: String(idx) }, (0, _preact.h)('span', {
          className: style.byline__name,
          dangerouslySetInnerHTML: { __html: author.name }
        }), ',', ' ');
      }));
    }
  }]);

  return Byline;
}(_preactPureComponent2.default);

exports.default = Byline;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

var _Message = __webpack_require__(24);

var _Date = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};

var ChatLog = function (_PureComponent) {
  _inherits(ChatLog, _PureComponent);

  function ChatLog() {
    _classCallCheck(this, ChatLog);

    return _possibleConstructorReturn(this, (ChatLog.__proto__ || Object.getPrototypeOf(ChatLog)).apply(this, arguments));
  }

  _createClass(ChatLog, [{
    key: 'render',
    value: function render() {
      var messages = this.props.messages;

      var className = '' + styles.chatLog + (this.props.className ? ' ' + this.props.className : '');

      return (0, _preact.h)('div', { className: className }, messages.map(function (message, idx) {
        return [(0, _preact.h)(_Date.Date, { date: message.date, index: idx, key: 'date_' + idx }), (0, _preact.h)(_Message.Message, {
          key: idx,
          isLastInGroup: isLastInGroup(messages, idx),
          message: message
        })];
      }));
    }
  }]);

  return ChatLog;
}(_preactPureComponent2.default);

function isLastInGroup(messages, index) {
  return messages.length - 1 === index;
}

exports.default = ChatLog;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _ImageMessage = __webpack_require__(25);

var _TextMessage = __webpack_require__(27);

var _index = __webpack_require__(28);

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var Message = exports.Message = function (_Component) {
  _inherits(Message, _Component);

  function Message() {
    _classCallCheck(this, Message);

    return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
  }

  _createClass(Message, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLastInGroup = _props.isLastInGroup,
          message = _props.message;
      var content = message.content;
      var type = content.type;

      switch (type) {
        case 'image':
          return (0, _preact.h)(_ImageMessage.ImageMessage, { message: message, isLastInGroup: isLastInGroup });
        case 'images':
          return (0, _preact.h)(_index.ImagesMessage, { message: message, isLastInGroup: isLastInGroup });
        case 'text':
          return (0, _preact.h)(_TextMessage.TextMessage, { message: message, isLastInGroup: isLastInGroup });
        default:
          throw new Error('Unknown message type ' + type);
      }
    }
  }]);

  return Message;
}(_preact.Component);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageMessage = undefined;

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(2);

var _index = __webpack_require__(4);

var _imageUrl = __webpack_require__(5);

//  @jsx h

var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};

var ImageMessage = exports.ImageMessage = function ImageMessage(props) {
  var message = props.message,
      isLastInGroup = props.isLastInGroup;
  var from = message.from,
      content = message.content;
  var name = from.name,
      side = from.side,
      display = from.display;

  var showAvatar = ['avatar', 'both'].indexOf(display) !== -1;
  var showName = ['name', 'both'].indexOf(display) !== -1;
  var imageSrc = (0, _imageUrl.getImageUrl)(content.image, { width: 320, ratio: '1:1' });

  return (0, _preact.h)('div', { className: (0, _dhUtils.bem)(styles.message, side, { showAvatar: showAvatar, isLastInGroup: isLastInGroup }) }, (0, _preact.h)('span', { className: 'nrk-sr' }, name, ':'), showAvatar && (0, _preact.h)(_index.Avatar, { person: from }), (0, _preact.h)('div', { className: (0, _dhUtils.bem)(styles.message__content, side, { showName: showName }) }, (0, _preact.h)('span', { 'aria-hidden': true, className: (0, _dhUtils.bem)(styles.message__name, side) }, showName && name), (0, _preact.h)('span', { className: (0, _dhUtils.bem)(styles.message__image, side) }, (0, _preact.h)('img', {
    src: imageSrc,
    alt: content.image.alt || '',
    nopin: 'nopin',
    'data-pin-nopin': 'true'
  }))));
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarImage = AvatarImage;

var _preact = __webpack_require__(0);

var _imageUrl = __webpack_require__(5);

//  @jsx h

var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};

function AvatarImage(props) {
  var image = props.image,
      alt = props.alt,
      title = props.title;

  return (0, _preact.h)('img', {
    className: styles.avatarImage,
    title: title,
    src: (0, _imageUrl.getImageUrl)(image),
    alt: alt,
    nopin: 'no-pin',
    'data-pin-nopin': 'true'
  });
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextMessage = undefined;

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(2);

var _Avatar = __webpack_require__(4);

var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
}; //  @jsx h

var TextMessage = exports.TextMessage = function TextMessage(props) {
  var message = props.message,
      isLastInGroup = props.isLastInGroup;
  var from = message.from,
      content = message.content;
  var name = from.name,
      side = from.side,
      display = from.display;

  var showAvatar = ['avatar', 'both'].indexOf(display) !== -1;
  var showName = ['name', 'both'].indexOf(display) !== -1;

  return (0, _preact.h)('div', { className: (0, _dhUtils.bem)(styles.message, side, { showAvatar: showAvatar, isLastInGroup: isLastInGroup }) }, (0, _preact.h)('span', { className: 'nrk-sr' }, name, ':'), showAvatar && (0, _preact.h)(_Avatar.Avatar, { person: from }), (0, _preact.h)('div', { className: (0, _dhUtils.bem)(styles.message__content, side, { showName: showName }) }, (0, _preact.h)('span', { 'aria-hidden': true, className: (0, _dhUtils.bem)(styles.message__name, side) }, showName && name), (0, _preact.h)('span', {
    className: (0, _dhUtils.bem)(styles.message__text, side),
    dangerouslySetInnerHTML: { __html: content.message }
  })));
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImagesMessage = undefined;

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(2);

var _index = __webpack_require__(4);

var _imageUrl = __webpack_require__(5);

//  @jsx h

var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};

var ImagesMessage = exports.ImagesMessage = function ImagesMessage(props) {
  var message = props.message,
      isLastInGroup = props.isLastInGroup;
  var from = message.from,
      content = message.content;
  var name = from.name,
      side = from.side,
      display = from.display;

  var showAvatar = ['avatar', 'both'].indexOf(display) !== -1;
  var showName = ['name', 'both'].indexOf(display) !== -1;

  return (0, _preact.h)('div', { className: (0, _dhUtils.bem)(styles.message, side, { showAvatar: showAvatar, isLastInGroup: isLastInGroup }) }, (0, _preact.h)('span', { className: 'nrk-sr' }, name, ':'), showAvatar && (0, _preact.h)(_index.Avatar, { person: from }), (0, _preact.h)('div', { className: (0, _dhUtils.bem)(styles.message__content, side, { showName: showName }) }, (0, _preact.h)('span', { 'aria-hidden': true, className: (0, _dhUtils.bem)(styles.message__name, side) }, showName && name), (0, _preact.h)('ul', { className: (0, _dhUtils.bem)(styles.message__images, side) }, content.images.map(function (image, idx) {
    var imageSrc = (0, _imageUrl.getImageUrl)(image, { width: 160, ratio: '1:1' });
    return (0, _preact.h)('li', { key: idx }, (0, _preact.h)('img', {
      src: imageSrc,
      alt: image.alt || '',
      nopin: 'nopin',
      'data-pin-nopin': 'true'
    }));
  }))));
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Date = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(2);

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};

var Date = exports.Date = function (_Component) {
  _inherits(Date, _Component);

  function Date() {
    _classCallCheck(this, Date);

    return _possibleConstructorReturn(this, (Date.__proto__ || Object.getPrototypeOf(Date)).apply(this, arguments));
  }

  _createClass(Date, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          date = _props.date,
          index = _props.index;

      if (!date) return null;

      return (0, _preact.h)('h4', {
        className: (0, _dhUtils.bem)(styles.date, { isFirst: index === 0 }),
        dangerouslySetInnerHTML: { __html: date }
      });
    }
  }]);

  return Date;
}(_preact.Component);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(2);

var _index = __webpack_require__(31);

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/** @jsx h */


var styles = {
  'emailList': 'dhfc-1_0_0-beta_26-emailList',
  'email': 'dhfc-1_0_0-beta_26-email',
  'email--left': 'dhfc-1_0_0-beta_26-email--left',
  'email--right': 'dhfc-1_0_0-beta_26-email--right',
  'email__header': 'dhfc-1_0_0-beta_26-email__header'
};

var nbsp = String.fromCharCode(160);

var EmailList = function (_Component) {
  _inherits(EmailList, _Component);

  function EmailList() {
    _classCallCheck(this, EmailList);

    return _possibleConstructorReturn(this, (EmailList.__proto__ || Object.getPrototypeOf(EmailList)).apply(this, arguments));
  }

  _createClass(EmailList, [{
    key: 'render',
    value: function render() {
      var emails = this.props.emails;

      return (0, _preact.h)('div', { className: styles.emailList }, emails.map(function (email, idx) {
        var datetime = email.datetime,
            from = email.from,
            to = email.to,
            subject = email.subject,
            message = email.message,
            align = email.align;

        return (0, _preact.h)('div', { className: (0, _dhUtils.bem)(styles.email, align), key: idx }, (0, _preact.h)('div', { className: styles.email__header }, from && (0, _preact.h)('div', null, (0, _preact.h)('strong', null, 'Fra:'), ' ', from), to && (0, _preact.h)('div', null, (0, _preact.h)('strong', null, 'Til:'), ' ', to), datetime && (0, _preact.h)('div', { className: styles.email_header_datetime }, (0, _preact.h)('strong', null, 'Sendt:'), ' ', datetime), subject && (0, _preact.h)('div', null, (0, _preact.h)('strong', null, 'Emne:'), ' ', subject)), (0, _preact.h)(_index.HtmlContent, { content: message && message.replace(nbsp, ' ') }));
      }));
    }
  }]);

  return EmailList;
}(_preact.Component);

exports.default = EmailList;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HtmlContent = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/** @jsx h */
var HtmlContent = exports.HtmlContent = function (_Component) {
  _inherits(HtmlContent, _Component);

  function HtmlContent() {
    _classCallCheck(this, HtmlContent);

    return _possibleConstructorReturn(this, (HtmlContent.__proto__ || Object.getPrototypeOf(HtmlContent)).apply(this, arguments));
  }

  _createClass(HtmlContent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.content !== this.props.content;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          className = _props.className,
          dataKey = _props.dataKey;

      switch (this.props.type) {
        case 'p':
          return (0, _preact.h)('p', { className: className, dangerouslySetInnerHTML: { __html: content }, 'data-key': dataKey });
        case 'div':
          return (0, _preact.h)('div', { className: className, dangerouslySetInnerHTML: { __html: content }, 'data-key': dataKey });
        default:
          return (0, _preact.h)('span', { className: className, dangerouslySetInnerHTML: { __html: content }, 'data-key': dataKey });
      }
    }
  }]);

  return HtmlContent;
}(_preact.Component);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var style = {
  'figure': 'dhfc-1_0_0-beta_26-figure',
  'figure__credit': 'dhfc-1_0_0-beta_26-figure__credit'
};

var Figure = function (_PureComponent) {
  _inherits(Figure, _PureComponent);

  function Figure() {
    _classCallCheck(this, Figure);

    return _possibleConstructorReturn(this, (Figure.__proto__ || Object.getPrototypeOf(Figure)).apply(this, arguments));
  }

  _createClass(Figure, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          caption = _props.caption,
          credit = _props.credit,
          media = _props.media;

      var className = '' + style.figure + (this.props.className ? ' ' + this.props.className : '');

      return (0, _preact.h)('figure', { className: className }, media, caption && (0, _preact.h)('figcaption', null, caption.map(function (text, idx) {
        return (0, _preact.h)('p', { dangerouslySetInnerHTML: { __html: text }, key: String(idx) });
      }), credit && (0, _preact.h)('div', { className: style.figure__credit }, credit)));
    }
  }]);

  return Figure;
}(_preactPureComponent2.default);

exports.default = Figure;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

/* eslint-disable jsx-a11y/heading-has-content */

var style = {
  'heading': 'dhfc-1_0_0-beta_26-heading'
};

var Heading = function (_PureComponent) {
  _inherits(Heading, _PureComponent);

  function Heading() {
    _classCallCheck(this, Heading);

    return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
  }

  _createClass(Heading, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          html = _props.html,
          level = _props.level;

      var className = '' + style.heading + (this.props.className ? ' ' + this.props.className : '');

      var htmlProps = {
        className: className
      };

      if (html) {
        htmlProps.dangerouslySetInnerHTML = { __html: html };
      } else {
        htmlProps.children = children;
      }

      switch (level) {
        case 2:
          return (0, _preact.h)('h2', htmlProps);

        case 3:
          return (0, _preact.h)('h3', htmlProps);

        case 4:
          return (0, _preact.h)('h4', htmlProps);

        case 5:
          return (0, _preact.h)('h5', htmlProps);

        case 6:
          return (0, _preact.h)('h6', htmlProps);

        default:
          return (0, _preact.h)('h1', htmlProps);
      }
    }
  }]);

  return Heading;
}(_preactPureComponent2.default);

exports.default = Heading;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var style = {
  'icon': 'dhfc-1_0_0-beta_26-icon'
}; //  @jsx h

function Icon(props) {
  var className = '' + style.icon + (props.className ? ' ' + props.className : '');

  return (0, _preact.h)('svg', {
    className: className,
    'aria-hidden': props['aria-hidden'],
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-' + props.symbol + '" />'
    }
  });
}

exports.default = Icon;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var style = {
  'list': 'dhfc-1_0_0-beta_26-list'
};

var List = function (_PureComponent) {
  _inherits(List, _PureComponent);

  function List() {
    _classCallCheck(this, List);

    return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
  }

  _createClass(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          type = _props.type;

      var className = '' + style.list + (this.props.className ? ' ' + this.props.className : '');

      if (type === 'numbered') {
        return (0, _preact.h)('ol', { className: className }, children);
      }

      return (0, _preact.h)('ul', { className: className }, children);
    }
  }]);

  return List;
}(_preactPureComponent2.default);

exports.default = List;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var ListItem = function (_PureComponent) {
  _inherits(ListItem, _PureComponent);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          html = _props.html;

      if (html) {
        return (0, _preact.h)('li', { dangerouslySetInnerHTML: { __html: html } });
      }

      return (0, _preact.h)('li', null, children);
    }
  }]);

  return ListItem;
}(_preactPureComponent2.default);

exports.default = ListItem;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var style = {
  'paragraph': 'dhfc-1_0_0-beta_26-paragraph'
};

var Paragraph = function (_PureComponent) {
  _inherits(Paragraph, _PureComponent);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).apply(this, arguments));
  }

  _createClass(Paragraph, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          html = _props.html;

      var className = '' + style.paragraph + (this.props.className ? ' ' + this.props.className : '');

      if (html) {
        return (0, _preact.h)('p', { className: className, dangerouslySetInnerHTML: { __html: html } });
      }

      return (0, _preact.h)('p', { className: className }, children);
    }
  }]);

  return Paragraph;
}(_preactPureComponent2.default);

exports.default = Paragraph;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

/* eslint-disable jsx-a11y/aria-role */

var style = {
  'pullQuote': 'dhfc-1_0_0-beta_26-pullQuote',
  'pullQuote__content': 'dhfc-1_0_0-beta_26-pullQuote__content',
  'pullQuote__footer': 'dhfc-1_0_0-beta_26-pullQuote__footer'
};

var PullQuote = function (_PureComponent) {
  _inherits(PullQuote, _PureComponent);

  function PullQuote() {
    _classCallCheck(this, PullQuote);

    return _possibleConstructorReturn(this, (PullQuote.__proto__ || Object.getPrototypeOf(PullQuote)).apply(this, arguments));
  }

  _createClass(PullQuote, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cite = _props.cite,
          html = _props.html;

      var className = '' + style.pullQuote + (this.props.className ? ' ' + this.props.className : '');

      return (0, _preact.h)('blockquote', { className: className }, (0, _preact.h)('div', { className: style.pullQuote__content }, (0, _preact.h)('p', { dangerouslySetInnerHTML: { __html: html } })), cite && (0, _preact.h)('footer', { className: style.pullQuote__footer }, (0, _preact.h)('cite', { role: 'text' }, (0, _preact.h)('svg', { viewBox: '0 0 20 30', 'aria-hidden': 'true' }, (0, _preact.h)('path', { d: 'M 5.5,5.5 L5.5,24.5 L14.5,24.5' }), (0, _preact.h)('circle', { cx: '5.5', cy: '5.5', r: '3.5' })), (0, _preact.h)('span', {
        dangerouslySetInnerHTML: {
          __html: "<span class=\"nrk-sr\">\u2013 </span>" + (cite || '')
        }
      }))));
    }
  }]);

  return PullQuote;
}(_preactPureComponent2.default);

exports.default = PullQuote;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _dhUtils = __webpack_require__(2);

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

var _Video = __webpack_require__(6);

var _Video2 = _interopRequireDefault(_Video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var style = {
  'responsiveVideo': 'dhfc-1_0_0-beta_26-responsiveVideo',
  'responsiveVideo__720p': 'dhfc-1_0_0-beta_26-responsiveVideo__720p',
  'responsiveVideo--1080p': 'dhfc-1_0_0-beta_26-responsiveVideo--1080p',
  'responsiveVideo__1080p': 'dhfc-1_0_0-beta_26-responsiveVideo__1080p'
};

var THRESHOLD_1080P = 960;

var ResponsiveVideo = function (_PureComponent) {
  _inherits(ResponsiveVideo, _PureComponent);

  function ResponsiveVideo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ResponsiveVideo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResponsiveVideo.__proto__ || Object.getPrototypeOf(ResponsiveVideo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      time: 0
    }, _this.handleTimeupdate = function (time) {
      var onTimeupdate = _this.props.onTimeupdate;

      _this.setState({ time: time });

      if (onTimeupdate) {
        onTimeupdate(time);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ResponsiveVideo, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevIs1080p = prevProps.viewport.width >= THRESHOLD_1080P;
      var is1080p = this.props.viewport.width >= THRESHOLD_1080P;

      if (is1080p !== prevIs1080p) {
        this.seek(this.state.time);
      }
    }
  }, {
    key: 'seek',
    value: function seek(time) {
      var is1080p = this.props.viewport.width >= THRESHOLD_1080P;

      if (is1080p) {
        this.resolution1080p.seek(time);
      } else {
        this.resolution720p.seek(time);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          resolution720p = _props.resolution720p,
          resolution1080p = _props.resolution1080p,
          viewport = _props.viewport,
          restProps = _objectWithoutProperties(_props, ['playing', 'resolution720p', 'resolution1080p', 'viewport']);

      if (!resolution720p) {
        throw new Error('Missing `resolution720p` property');
      }

      if (!resolution1080p) {
        throw new Error('Missing `resolution1080p` property');
      }

      var isValidViewport = viewport.width > -1 && viewport.height > -1;
      var is1080p = viewport.width >= THRESHOLD_1080P;
      var className = '' + (0, _dhUtils.bem)(style.responsiveVideo, is1080p && '1080p') + (this.props.className ? ' ' + this.props.className : '');

      return (0, _preact.h)('div', { className: className }, (0, _preact.h)(_Video2.default, _extends({}, resolution720p, restProps, {
        className: style.responsiveVideo__720p,
        playing: isValidViewport && !is1080p && playing,
        onTimeupdate: this.handleTimeupdate,
        ref: function ref(resolution720p) {
          return _this2.resolution720p = resolution720p;
        }
      })), (0, _preact.h)(_Video2.default, _extends({}, resolution1080p, restProps, {
        className: style.responsiveVideo__1080p,
        playing: isValidViewport && is1080p && playing,
        onTimeupdate: this.handleTimeupdate,
        ref: function ref(resolution1080p) {
          return _this2.resolution1080p = resolution1080p;
        }
      })));
    }
  }]);

  return ResponsiveVideo;
}(_preactPureComponent2.default);

exports.default = ResponsiveVideo;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _serumImagecropUtils = __webpack_require__(3);

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/** @jsx h */

var SerumImage = function (_PureComponent) {
  _inherits(SerumImage, _PureComponent);

  function SerumImage() {
    _classCallCheck(this, SerumImage);

    return _possibleConstructorReturn(this, (SerumImage.__proto__ || Object.getPrototypeOf(SerumImage)).apply(this, arguments));
  }

  _createClass(SerumImage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          alt = _props.alt,
          id = _props.id,
          quality = _props.quality,
          ratio = _props.ratio,
          width = _props.width;

      var src = (0, _serumImagecropUtils.createImageUrl)({
        id: id,
        width: width,
        quality: quality,
        ratio: ratio
      });

      return (0, _preact.h)('img', { className: className, src: src, alt: alt });
    }
  }]);

  return SerumImage;
}(_preactPureComponent2.default);

exports.default = SerumImage;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _serumImagecropUtils = __webpack_require__(3);

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

var _helpers = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/** @jsx h */

var SerumResponsivePicture = function (_PureComponent) {
  _inherits(SerumResponsivePicture, _PureComponent);

  function SerumResponsivePicture() {
    _classCallCheck(this, SerumResponsivePicture);

    return _possibleConstructorReturn(this, (SerumResponsivePicture.__proto__ || Object.getPrototypeOf(SerumResponsivePicture)).apply(this, arguments));
  }

  _createClass(SerumResponsivePicture, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          alt = _props.alt,
          id = _props.id,
          quality = _props.quality,
          ratio = _props.ratio;

      var defaultUrl = (0, _serumImagecropUtils.createImageUrl)({
        id: id,
        width: 1600,
        quality: quality,
        ratio: ratio || '16:9'
      });

      var horizontalSourceSet = (0, _helpers.createResponsiveSrcSet)({
        id: id,
        quality: quality,
        ratio: ratio || '16:9'
      });

      return (0, _preact.h)('picture', { className: className }, (0, _preact.h)('source', { srcSet: horizontalSourceSet }), (0, _preact.h)('img', { src: defaultUrl, alt: alt }));
    }
  }]);

  return SerumResponsivePicture;
}(_preactPureComponent2.default);

exports.default = SerumResponsivePicture;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _serumImagecropUtils = __webpack_require__(3);

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

var _helpers = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/** @jsx h */

var SerumSmartPicture = function (_PureComponent) {
  _inherits(SerumSmartPicture, _PureComponent);

  function SerumSmartPicture() {
    _classCallCheck(this, SerumSmartPicture);

    return _possibleConstructorReturn(this, (SerumSmartPicture.__proto__ || Object.getPrototypeOf(SerumSmartPicture)).apply(this, arguments));
  }

  _createClass(SerumSmartPicture, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          alt = _props.alt,
          horizontal = _props.horizontal,
          vertical = _props.vertical;

      var defaultUrl = (0, _serumImagecropUtils.createImageUrl)(_extends({}, horizontal, {
        width: 1600,
        ratio: '16:9'
      }));

      var horizontalSourceSet = (0, _helpers.createResponsiveSrcSet)(_extends({}, horizontal, {
        ratio: '16:9'
      }));

      var verticalSourceSet = (0, _helpers.createResponsiveSrcSet)(_extends({}, vertical, {
        ratio: '3:4'
      }));

      return (0, _preact.h)('picture', { className: className }, (0, _preact.h)('source', { media: '(min-aspect-ratio: 4/5)', srcSet: horizontalSourceSet }), (0, _preact.h)('source', { media: '(max-aspect-ratio: 4/5)', srcSet: verticalSourceSet }), (0, _preact.h)('img', { src: defaultUrl, alt: alt }));
    }
  }]);

  return SerumSmartPicture;
}(_preactPureComponent2.default);

exports.default = SerumSmartPicture;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _serumImagecropUtils = __webpack_require__(3);

var _preact = __webpack_require__(0);

var _helpers = __webpack_require__(7);

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/** @jsx h */

var SerumLazyResponsivePicture = function (_Component) {
  _inherits(SerumLazyResponsivePicture, _Component);

  function SerumLazyResponsivePicture() {
    _classCallCheck(this, SerumLazyResponsivePicture);

    return _possibleConstructorReturn(this, (SerumLazyResponsivePicture.__proto__ || Object.getPrototypeOf(SerumLazyResponsivePicture)).apply(this, arguments));
  }

  _createClass(SerumLazyResponsivePicture, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.load && !this.props.load) {
        this.loadImage();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'loadImage',
    value: function loadImage() {
      var _this2 = this;

      var loaderImage = new Image();
      if (this.visibleImage.dataset) {
        loaderImage.srcset = this.visibleImage.dataset.srcset || '';
        loaderImage.sizes = this.visibleImage.sizes || '';
      }
      loaderImage.src = this.visibleImage.dataset.src;
      if (typeof loaderImage.decode === 'function') {
        // Use Image Decode API to decode image upfront if available
        // (Unsure if this works when transferring src to other image, but worth the try)
        loaderImage.decode().then(function () {
          return _this2.updateImage(loaderImage);
        });
      } else if (loaderImage.complete) {
        this.updateImage(loaderImage);
      } else {
        loaderImage.onload = function () {
          return _this2.updateImage(loaderImage);
        };
      }
    }
  }, {
    key: 'updateImage',
    value: function updateImage(loaderImage) {
      var _this3 = this;

      requestAnimationFrame(function () {
        _this3.visibleImage.src = loaderImage.currentSrc || loaderImage.src;
        _this3.visibleImage.style.filter = 'blur(0)';
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          className = _props.className,
          alt = _props.alt,
          id = _props.id,
          _props$quality = _props.quality,
          quality = _props$quality === undefined ? 0.6 : _props$quality,
          _props$ratio = _props.ratio,
          ratio = _props$ratio === undefined ? '16:9' : _props$ratio,
          sizes = _props.sizes;

      var placeholderSrc = (0, _serumImagecropUtils.createImageUrl)({ id: id, width: 100, quality: 0.6, ratio: ratio });

      var defaultUrl = (0, _serumImagecropUtils.createImageUrl)({ id: id, width: 1600, quality: quality, ratio: ratio });

      var sourceSet = (0, _helpers.createResponsiveSrcSet)({ id: id, quality: quality, ratio: ratio });

      return (0, _preact.h)('picture', { className: className, style: { display: 'block', overflow: 'hidden' } }, (0, _preact.h)('img', {
        src: placeholderSrc,
        alt: alt,
        'data-src': defaultUrl,
        'data-srcset': sourceSet,
        style: { width: '100%', filter: 'blur(10px)', transition: 'filter 500ms' },
        sizes: sizes,
        ref: function ref(elm) {
          return _this4.visibleImage = elm;
        }
      }));
    }
  }]);

  return SerumLazyResponsivePicture;
}(_preact.Component);

exports.default = SerumLazyResponsivePicture;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _dhUtils = __webpack_require__(2);

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var style = {
  'slideshow': 'dhfc-1_0_0-beta_26-slideshow',
  'slideshow__slide': 'dhfc-1_0_0-beta_26-slideshow__slide',
  'slideshow__slide--stacked': 'dhfc-1_0_0-beta_26-slideshow__slide--stacked',
  'slideshow__slide--visible': 'dhfc-1_0_0-beta_26-slideshow__slide--visible',
  'slideshow__slide--active': 'dhfc-1_0_0-beta_26-slideshow__slide--active'
};

var Slide = function (_PureComponent) {
  _inherits(Slide, _PureComponent);

  function Slide() {
    _classCallCheck(this, Slide);

    return _possibleConstructorReturn(this, (Slide.__proto__ || Object.getPrototypeOf(Slide)).apply(this, arguments));
  }

  _createClass(Slide, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          stacked = _props.stacked,
          visible = _props.visible;

      var className = '' + (0, _dhUtils.bem)(style.slideshow__slide, stacked && 'stacked', visible && 'visible', active && 'active') + (this.props.className ? ' ' + this.props.className : '');

      return (0, _preact.h)('div', { className: className }, children);
    }
  }]);

  return Slide;
}(_preactPureComponent2.default);

exports.default = Slide;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var style = {
  'slideshow': 'dhfc-1_0_0-beta_26-slideshow',
  'slideshow__slide': 'dhfc-1_0_0-beta_26-slideshow__slide',
  'slideshow__slide--stacked': 'dhfc-1_0_0-beta_26-slideshow__slide--stacked',
  'slideshow__slide--visible': 'dhfc-1_0_0-beta_26-slideshow__slide--visible',
  'slideshow__slide--active': 'dhfc-1_0_0-beta_26-slideshow__slide--active'
};

var Slideshow = function (_PureComponent) {
  _inherits(Slideshow, _PureComponent);

  function Slideshow() {
    _classCallCheck(this, Slideshow);

    return _possibleConstructorReturn(this, (Slideshow.__proto__ || Object.getPrototypeOf(Slideshow)).apply(this, arguments));
  }

  _createClass(Slideshow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          viewport = _props.viewport;

      var activeIndex = this.props.activeIndex || 0;
      var className = '' + style.slideshow + (this.props.className ? ' ' + this.props.className : '');

      var inlineStyle = {};

      if (viewport && viewport.height > -1) {
        inlineStyle.height = viewport.height + 'px';
      }

      return (0, _preact.h)('div', {
        className: className,
        style: inlineStyle,
        'data-active-index': String(activeIndex)
      }, children.map(function (child, idx) {
        if (idx <= activeIndex) {
          child.attributes.stacked = true;
        }

        if (idx >= activeIndex - 1 && idx <= activeIndex + 1) {
          child.attributes.visible = true;
        }

        child.attributes.active = idx === activeIndex;

        return child;
      }));
    }
  }]);

  return Slideshow;
}(_preactPureComponent2.default);

exports.default = Slideshow;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _dhUtils = __webpack_require__(2);

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

var _Video = __webpack_require__(6);

var _Video2 = _interopRequireDefault(_Video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var style = {
  'smartVideo': 'dhfc-1_0_0-beta_26-smartVideo',
  'smartVideo__720p': 'dhfc-1_0_0-beta_26-smartVideo__720p',
  'smartVideo--horizontal': 'dhfc-1_0_0-beta_26-smartVideo--horizontal',
  'smartVideo--1080p': 'dhfc-1_0_0-beta_26-smartVideo--1080p',
  'smartVideo__960p': 'dhfc-1_0_0-beta_26-smartVideo__960p',
  'smartVideo__1080p': 'dhfc-1_0_0-beta_26-smartVideo__1080p'
};

var THRESHOLD_1080P = 960;
var THRESHOLD_HORIZONTAL = 2 / 3;

var SmartVideo = function (_PureComponent) {
  _inherits(SmartVideo, _PureComponent);

  function SmartVideo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SmartVideo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmartVideo.__proto__ || Object.getPrototypeOf(SmartVideo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      time: 0
    }, _this.handleTimeupdate = function (time) {
      var onTimeupdate = _this.props.onTimeupdate;

      _this.setState({ time: time });

      if (onTimeupdate) {
        onTimeupdate(time);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SmartVideo, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevIsHorizontal = prevProps.viewport.width / prevProps.viewport.height >= THRESHOLD_HORIZONTAL;
      var isHorizontal = this.props.viewport.width / this.props.viewport.height >= THRESHOLD_HORIZONTAL;

      var prevIs1080p = prevProps.viewport.width >= THRESHOLD_1080P;
      var is1080p = this.props.viewport.width >= THRESHOLD_1080P;

      if (prevIsHorizontal !== isHorizontal || is1080p !== prevIs1080p) {
        this.seek(this.state.time);
      }
    }
  }, {
    key: 'seek',
    value: function seek(time) {
      var viewport = this.props.viewport;

      var isHorizontal = viewport.width / viewport.height >= THRESHOLD_HORIZONTAL;
      var is1080p = viewport.width >= THRESHOLD_1080P;

      if (isHorizontal) {
        if (is1080p) {
          this.resolution1080p.seek(time);
        } else {
          this.resolution720p.seek(time);
        }
      } else {
        this.resolution960p.seek(time);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          resolution720p = _props.resolution720p,
          resolution960p = _props.resolution960p,
          resolution1080p = _props.resolution1080p,
          viewport = _props.viewport,
          restProps = _objectWithoutProperties(_props, ['playing', 'resolution720p', 'resolution960p', 'resolution1080p', 'viewport']);

      if (!resolution720p) {
        throw new Error('Missing `resolution720p` property');
      }

      if (!resolution960p) {
        throw new Error('Missing `resolution960p` property');
      }

      if (!resolution1080p) {
        throw new Error('Missing `resolution1080p` property');
      }

      var isValidViewport = viewport.width > -1 && viewport.height > -1;
      var isHorizontal = viewport.width / viewport.height >= THRESHOLD_HORIZONTAL;
      var is1080p = isHorizontal && viewport.width >= THRESHOLD_1080P;
      var className = '' + (0, _dhUtils.bem)(style.smartVideo, {
        '1080p': is1080p,
        horizontal: isHorizontal
      }) + (this.props.className ? ' ' + this.props.className : '');

      return (0, _preact.h)('div', { className: className }, (0, _preact.h)(_Video2.default, _extends({}, resolution720p, restProps, {
        className: style.smartVideo__720p,
        playing: isValidViewport && isHorizontal && !is1080p && playing,
        onTimeupdate: this.handleTimeupdate,
        ref: function ref(resolution720p) {
          return _this2.resolution720p = resolution720p;
        }
      })), (0, _preact.h)(_Video2.default, _extends({}, resolution960p, restProps, {
        className: style.smartVideo__960p,
        playing: isValidViewport && !isHorizontal && !is1080p && playing,
        onTimeupdate: this.handleTimeupdate,
        ref: function ref(resolution960p) {
          return _this2.resolution960p = resolution960p;
        }
      })), (0, _preact.h)(_Video2.default, _extends({}, resolution1080p, restProps, {
        className: style.smartVideo__1080p,
        playing: isValidViewport && isHorizontal && is1080p && playing,
        onTimeupdate: this.handleTimeupdate,
        ref: function ref(resolution1080p) {
          return _this2.resolution1080p = resolution1080p;
        }
      })));
    }
  }]);

  return SmartVideo;
}(_preactPureComponent2.default);

exports.default = SmartVideo;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

var _warn = __webpack_require__(48);

var _warn2 = _interopRequireDefault(_warn);

var _Scrubber = __webpack_require__(49);

var _Scrubber2 = _interopRequireDefault(_Scrubber);

var _TogglePlayButton = __webpack_require__(50);

var _TogglePlayButton2 = _interopRequireDefault(_TogglePlayButton);

var _ToggleMuteButton = __webpack_require__(51);

var _ToggleMuteButton2 = _interopRequireDefault(_ToggleMuteButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var style = {
  'videoPlayer': 'dhfc-1_0_0-beta_26-videoPlayer',
  'videoPlayer__container': 'dhfc-1_0_0-beta_26-videoPlayer__container',
  'videoPlayer__caption': 'dhfc-1_0_0-beta_26-videoPlayer__caption',
  'videoPlayer__controls': 'dhfc-1_0_0-beta_26-videoPlayer__controls',
  'videoPlayer__togglePlayButton': 'dhfc-1_0_0-beta_26-videoPlayer__togglePlayButton',
  'videoPlayer__toggleMuteButton': 'dhfc-1_0_0-beta_26-videoPlayer__toggleMuteButton'
};

var VideoPlayer = function (_PureComponent) {
  _inherits(VideoPlayer, _PureComponent);

  function VideoPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VideoPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      caption: null,
      duration: 0,
      isPlaying: false,
      time: 0
    }, _this.handleUserTogglePlay = function () {
      _this.props.onUserTogglePlay();
    }, _this.handleUserToggleMute = function () {
      _this.props.onUserToggleMute();
    }, _this.handleScrubberPositionUpdate = function (position) {
      if (_this.video) {
        _this.video.seek(_this.state.duration * position);
      } else {
        (0, _warn2.default)('[@nrk/dh-feature-components] No video reference');
      }
    }, _this.handleCaptionCueEnter = function (caption) {
      _this.setState({ caption: caption });
    }, _this.handleCaptionCueExit = function () {
      _this.setState({ caption: null });
    }, _this.handleDurationChange = function (duration) {
      _this.setState({ duration: duration });
    }, _this.handlePlay = function () {
      var onPlay = _this.props.onPlay;

      _this.setState({ isPlaying: true });

      if (onPlay) {
        onPlay();
      }
    }, _this.handlePause = function () {
      var onPause = _this.props.onPause;

      _this.setState({ isPlaying: false });

      if (onPause) {
        onPause();
      }
    }, _this.handleTimeupdate = function (time) {
      _this.setState({ time: time });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VideoPlayer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          muted = _props.muted,
          playing = _props.playing,
          video = _props.video;
      var _state = this.state,
          caption = _state.caption,
          duration = _state.duration,
          isPlaying = _state.isPlaying,
          time = _state.time;

      if (!video.attributes) {
        throw new Error('The `video` property must be a virtual node');
      }

      var className = '' + style.videoPlayer + (this.props.className ? ' ' + this.props.className : '');

      video.attributes.muted = muted;
      video.attributes.playing = playing;
      video.attributes.playsInline = true;
      video.attributes.ref = function (video) {
        return _this2.video = video;
      };
      video.attributes.onPlay = this.handlePlay;
      video.attributes.onPause = this.handlePause;
      video.attributes.onCaptionCueEnter = this.handleCaptionCueEnter;
      video.attributes.onCaptionCueExit = this.handleCaptionCueExit;
      video.attributes.onDurationChange = this.handleDurationChange;
      video.attributes.onTimeupdate = this.handleTimeupdate;

      return (0, _preact.h)('div', { className: className }, (0, _preact.h)('div', { className: style.videoPlayer__container }, video, caption && (0, _preact.h)('div', { className: style.videoPlayer__caption, 'aria-hidden': 'true' }, caption.text.split('\n').map(function (text, idx) {
        return (0, _preact.h)('div', { key: String(idx) }, (0, _preact.h)('span', { dangerouslySetInnerHTML: { __html: text } }));
      })), (0, _preact.h)('div', { className: style.videoPlayer__controls }, (0, _preact.h)(_TogglePlayButton2.default, {
        className: style.videoPlayer__togglePlayButton,
        playing: isPlaying,
        onClick: this.handleUserTogglePlay
      }), (0, _preact.h)(_Scrubber2.default, {
        time: time,
        duration: duration,
        onPositionUpdate: this.handleScrubberPositionUpdate
      }), (0, _preact.h)(_ToggleMuteButton2.default, {
        className: style.videoPlayer__toggleMuteButton,
        muted: muted,
        onClick: this.handleUserToggleMute
      }))));
    }
  }]);

  return VideoPlayer;
}(_preactPureComponent2.default);

exports.default = VideoPlayer;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warn;
function warn() {
  var _console;

  typeof window !== 'undefined' && console && console.warn && (_console = console).warn.apply(_console, arguments);
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var style = {
  'scrubber': 'dhfc-1_0_0-beta_26-scrubber',
  'scrubber__bgBar': 'dhfc-1_0_0-beta_26-scrubber__bgBar',
  'scrubber__bufferedBar': 'dhfc-1_0_0-beta_26-scrubber__bufferedBar',
  'scrubber__playedBar': 'dhfc-1_0_0-beta_26-scrubber__playedBar'
};

var Scrubber = function (_PureComponent) {
  _inherits(Scrubber, _PureComponent);

  function Scrubber() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Scrubber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scrubber.__proto__ || Object.getPrototypeOf(Scrubber)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      left: 0,
      width: 0,
      isScrubbing: false,
      position: null
    }, _this.handleKeyDown = function (evt) {
      var _this$props = _this.props,
          duration = _this$props.duration,
          time = _this$props.time,
          onPositionUpdate = _this$props.onPositionUpdate;

      if (onPositionUpdate) {
        var nextTime = time;

        switch (evt.key) {
          case 'ArrowLeft':
            nextTime -= 1;
            break;
          case 'ArrowRight':
            nextTime += 1;
            break;
        }

        onPositionUpdate(Math.max(Math.min(nextTime / duration, 1), 0));
      }
    }, _this.handleMouseDown = function (evt) {
      evt.preventDefault();
      _this.focus();
      _this.start(evt.pageX);
      _this.elm.addEventListener('mousemove', _this.handleMouseMove);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseMove = function (evt) {
      _this.move(evt.pageX);
    }, _this.handleMouseUp = function (evt) {
      _this.focus();
      _this.end();
      _this.elm.removeEventListener('mousemove', _this.handleMouseMove);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleResize = function () {
      var rect = _this.bgElm.getBoundingClientRect();

      _this.setState({
        left: Math.floor(rect.left),
        width: rect.width
      });
    }, _this.handleTouchStart = function (evt) {
      if (evt.touches.length === 1) {
        evt.preventDefault();
        _this.focus();
        _this.start(evt.touches[0].clientX);
        _this.elm.addEventListener('touchmove', _this.handleTouchMove);
        window.addEventListener('touchend', _this.handleTouchEnd);
      }
    }, _this.handleTouchMove = function (evt) {
      if (evt.touches.length === 1) {
        _this.move(evt.touches[0].clientX);
      }
    }, _this.handleTouchEnd = function (evt) {
      _this.focus();
      _this.end();
      _this.elm.removeEventListener('touchmove', _this.handleTouchMove);
      window.removeEventListener('touchend', _this.handleTouchEnd);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Scrubber, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onPositionUpdate) {
        this.elm.addEventListener('keydown', this.handleKeyDown);
        this.elm.addEventListener('mousedown', this.handleMouseDown);
        this.elm.addEventListener('touchstart', this.handleTouchStart);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onPositionUpdate) {
        this.elm.removeEventListener('keydown', this.handleKeyDown);
        this.elm.removeEventListener('mousedown', this.handleMouseDown);
        this.elm.removeEventListener('touchstart', this.handleTouchStart);
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.handleElm.focus();
    }
  }, {
    key: 'start',
    value: function start(clientX) {
      if (this.positionTimeout) {
        clearTimeout(this.positionTimeout);
      }

      this.setState({
        position: (clientX - this.state.left) / this.state.width,
        isScrubbing: true
      });
    }
  }, {
    key: 'move',
    value: function move(clientX) {
      this.setState({
        position: Math.max(Math.min((clientX - this.state.left) / this.state.width, 1), 0)
      });
    }
  }, {
    key: 'end',
    value: function end() {
      var _this2 = this;

      if (this.props.onPositionUpdate && this.state.position !== null) {
        this.props.onPositionUpdate(this.state.position);
      }

      this.setState({
        isScrubbing: false
      });

      this.positionTimeout = setTimeout(function () {
        _this2.setState({
          position: null
        });
      }, 350);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          duration = _props.duration,
          time = _props.time;

      var className = '' + style.scrubber + (this.props.className ? ' ' + this.props.className : '');
      var position = this.state.position !== null ? this.state.position : time / duration;

      return (0, _preact.h)('div', { className: className, ref: function ref(elm) {
          return _this3.elm = elm;
        } }, (0, _preact.h)('div', {
        className: style.scrubber__bgBar,
        ref: function ref(bgElm) {
          return _this3.bgElm = bgElm;
        }
      }), (0, _preact.h)('div', { className: style.scrubber__bufferedBar }), (0, _preact.h)('div', {
        className: style.scrubber__playedBar,
        style: { width: position * 100 + '%' }
      }), (0, _preact.h)('button', {
        ref: function ref(handleElm) {
          return _this3.handleElm = handleElm;
        },
        role: 'slider',
        'aria-valuemin': '0',
        'aria-valuemax': duration * 1000,
        'aria-valuenow': time * 1000,
        style: { left: position * 100 + '%' }
      }));
    }
  }]);

  return Scrubber;
}(_preactPureComponent2.default);

exports.default = Scrubber;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TogglePlayButton;

var _dhUtils = __webpack_require__(2);

var _preact = __webpack_require__(0);

//  @jsx h

var style = {
  'togglePlayButton': 'dhfc-1_0_0-beta_26-togglePlayButton',
  'togglePlayButton__pauseIcon': 'dhfc-1_0_0-beta_26-togglePlayButton__pauseIcon',
  'togglePlayButton--playing': 'dhfc-1_0_0-beta_26-togglePlayButton--playing',
  'togglePlayButton__playIcon': 'dhfc-1_0_0-beta_26-togglePlayButton__playIcon'
};

function TogglePlayButton(props) {
  var playing = props.playing;

  var className = '' + (0, _dhUtils.bem)(style.togglePlayButton, playing && 'playing') + (props.className ? ' ' + props.className : '');

  return (0, _preact.h)('button', { className: className, onClick: props.onClick }, (0, _preact.h)('span', { className: 'nrk-sr' }, playing ? 'Sett video på pause' : 'Spill av video'), (0, _preact.h)('svg', {
    className: style.togglePlayButton__pauseIcon,
    'aria-hidden': 'true',
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-media-pause" />'
    }
  }), (0, _preact.h)('svg', {
    className: style.togglePlayButton__playIcon,
    'aria-hidden': 'true',
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-media-play" />'
    }
  }));
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ToggleMuteButton;

var _dhUtils = __webpack_require__(2);

var _preact = __webpack_require__(0);

//  @jsx h

var style = {
  'toggleMuteButton': 'dhfc-1_0_0-beta_26-toggleMuteButton',
  'toggleMuteButton__volumeIcon': 'dhfc-1_0_0-beta_26-toggleMuteButton__volumeIcon',
  'toggleMuteButton--muted': 'dhfc-1_0_0-beta_26-toggleMuteButton--muted',
  'toggleMuteButton__mutedIcon': 'dhfc-1_0_0-beta_26-toggleMuteButton__mutedIcon'
};

function ToggleMuteButton(props) {
  var muted = props.muted;

  var className = '' + (0, _dhUtils.bem)(style.toggleMuteButton, muted && 'muted') + (props.className ? ' ' + props.className : '');

  return (0, _preact.h)('button', { className: className, onClick: props.onClick }, (0, _preact.h)('span', { className: 'nrk-sr' }, muted ? 'Slå på lyd' : 'Slå av lyd'), (0, _preact.h)('svg', {
    className: style.toggleMuteButton__mutedIcon,
    'aria-hidden': 'true',
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-media-volume--muted" />'
    }
  }), (0, _preact.h)('svg', {
    className: style.toggleMuteButton__volumeIcon,
    'aria-hidden': 'true',
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-media-volume--3" />'
    }
  }));
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _dhUtils = __webpack_require__(2);

var _preact = __webpack_require__(0);

var _preactPureComponent = __webpack_require__(1);

var _preactPureComponent2 = _interopRequireDefault(_preactPureComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

//  @jsx h

var ViewportIntersections = function (_PureComponent) {
  _inherits(ViewportIntersections, _PureComponent);

  function ViewportIntersections(props) {
    _classCallCheck(this, ViewportIntersections);

    var _this = _possibleConstructorReturn(this, (ViewportIntersections.__proto__ || Object.getPrototypeOf(ViewportIntersections)).call(this));

    _this.state = {
      intersections: props.children.map(function (child, idx) {
        return {
          isIntersecting: false,
          ratio: null
        };
      })
    };
    return _this;
  }

  _createClass(ViewportIntersections, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          onChange = _props.onChange,
          onEnter = _props.onEnter,
          onLeave = _props.onLeave,
          rootMargin = _props.rootMargin,
          threshold = _props.threshold;

      var childNodes = (0, _dhUtils.toArray)(this.elm.childNodes);

      this.intersectionObserver = new IntersectionObserver(function (entries) {
        var intersections = _this2.state.intersections.slice(0);

        entries.forEach(function (entry) {
          var idx = childNodes.indexOf(entry.target);
          var prevIntersection = intersections[idx];

          intersections.splice(idx, 1, {
            isIntersecting: entry.isIntersecting,
            ratio: entry.intersectionRatio
          });

          if (onEnter && !prevIntersection.isIntersecting && entry.isIntersecting) {
            onEnter(entry, idx);
          }

          if (onLeave && prevIntersection.isIntersecting && !entry.isIntersecting) {
            onLeave(entry, idx);
          }
        });

        _this2.setState({ intersections: intersections });

        if (onChange) {
          onChange(intersections);
        }
      }, {
        rootMargin: rootMargin || '0px 0px 0px 0px',
        threshold: threshold || 1.0
      });

      childNodes.forEach(function (childElm) {
        return _this2.intersectionObserver.observe(childElm);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.intersectionObserver.disconnect();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          className = _props2.className,
          children = _props2.children,
          style = _props2.style;

      return (0, _preact.h)('div', { ref: function ref(elm) {
          return _this3.elm = elm;
        }, className: className, style: style }, children);
    }
  }]);

  return ViewportIntersections;
}(_preactPureComponent2.default);

exports.default = ViewportIntersections;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : n(e["dh-analytics-utils"] = {});
}(undefined, function (e) {
  "use strict";
  function n() {
    return window.ga;
  }var t = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }return e;
  };e.createGoogleAnalyticsTracker = function (e) {
    var o = [],
        r = e.name,
        a = e.gaPropertyId,
        i = e.self,
        l = e.context;if (!(r && a && i && l)) throw new Error("Unable to create google analytics tracker. Please pass an object containing name, gaPropertyId, self and context to createGoogleAnalyticsTracker method");var c,
        s,
        d,
        u,
        f,
        g,
        p,
        y,
        w = (c = i.id, s = l.id, d = i.title, u = i.publishedDate, f = c === s, g = document.referrer, { dimension1: c ? "pp:" + c : null, dimension2: d || null, dimension3: u ? String(u.getFullYear()) : null, dimension4: u ? String(u.getMonth() + 1) : null, dimension5: u ? String(u.getDate()) : null, dimension6: g.replace(/^(https?:\/\/)?www./, "$1"), dimension7: g.replace(/^(https?:\/\/)/, "").replace(/^www./, ""), dimension10: f ? null : s ? "pp:" + s : null }),
        v = (p = o, y = !1, function (e, o, r, a, i) {
      if (!r.category || !r.action) throw new Error("Error sending event to google analytics: Event is missing mandatory fields category and/or action");n() ? (y || (function (e, n) {
        window.ga("create", { trackingId: n, cookieDomain: "auto", name: e }), window.ga(e + ".set", "anonymizeIp", !0);
      }(e, o), y = !0), window.ga(e + ".send", "event", function (e, n) {
        var o = {};e.hasOwnProperty("category") && (o.eventCategory = e.category), e.hasOwnProperty("action") && (o.eventAction = e.action), e.hasOwnProperty("label") && (o.eventLabel = e.label), e.hasOwnProperty("value") && (o.eventValue = e.value), o.nonInteraction = e.nonInteraction || !1;var r = t({}, n, e.fieldsObject);return t({}, o, r);
      }(r, a))) : p.push(r);
    }),
        m = setInterval(function () {
      if (n()) for (clearInterval(m); o.length;) {
        var e = o.shift();v(r, a, e, w);
      }
    }, 1e3);return { sendEvent: function sendEvent(e) {
        v(r, a, e, w);
      } };
  }, Object.defineProperty(e, "__esModule", { value: !0 });
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContextId = getContextId;
var POLOPOLY_ID_REGEX = /[1-9]{1,2}\.\d+/g;

function getContextId(url) {
  return extractPolopolyIdFromString(url);
}

function extractPolopolyIdFromString(str) {
  var matches = str.match(POLOPOLY_ID_REGEX);
  if (matches && matches.length) {
    return matches[0];
  }
  return null;
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// v1-bundle-59337d2c652bda67c0e4.js